import React from 'react';
import { Phone, Snowflake, Zap, Droplets, CheckCircle, MessageCircle, Clock, Shield, Award, Wrench } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const Services = () => {
  const whatsappNumber = '+966555150324';
  const whatsappLink = `https://wa.me/${whatsappNumber.replace('+', '')}`;

  const services = [
    {
      icon: Snowflake,
      title: 'صيانة وتركيب التكييف',
      slug: 'ac-maintenance',
      description: 'خدمات شاملة للتكييف والتبريد بأحدث التقنيات وأعلى معايير الجودة',
      image: 'https://housecraft.me/gfhdjsdhfd333.png',
      services: [
        'تركيب مكيفات سبليت وشباك جديدة',
        'فك ونقل المكيفات',
        'تنظيف وغسيل مكيفات بالبخار',
        'تعبئة غاز الفريون',
        'إصلاح تسريب المياه من المكيف',
        'صيانة دورية للمكيفات',
        'تغيير فلاتر الهواء',
        'فحص وإصلاح الضاغط',
        'معالجة الروائح الكريهة',
        'صيانة المكيفات المركزية'
      ],
      benefits: [
        'ضمان على قطع الغيار',
        'فنيون معتمدون',
        'خدمة سريعة خلال 24 ساعة',
        'استخدام قطع غيار أصلية'
      ]
    },
    {
      icon: Zap,
      title: 'خدمات الكهرباء',
      slug: 'electrical-services',
      description: 'حلول كهربائية متكاملة وآمنة لجميع احتياجاتك المنزلية',
      image: 'https://housecraft.me/gfhdjsdhfd333.png',
      services: [
        'تركيب وصيانة لوحات الكهرباء',
        'إصلاح الأعطال والتماسات الكهربائية',
        'تركيب الإنارة والثريات',
        'تركيب مراوح السقف',
        'تمديدات كهربائية كاملة',
        'تركيب الأفياش والمفاتيح',
        'فحص واختبار الدوائر الكهربائية',
        'تركيب أجهزة الحماية من الصواعق',
        'صيانة السخانات الكهربائية',
        'تركيب أنظمة الإنذار'
      ],
      benefits: [
        'التزام بمعايير السلامة',
        'كهربائيون مرخصون',
        'فحص شامل مجاني',
        'ضمان على جميع الأعمال'
      ]
    },
    {
      icon: Droplets,
      title: 'خدمات السباكة والصرف',
      slug: 'plumbing-services',
      description: 'خدمات سباكة احترافية وحلول سريعة لجميع مشاكل المياه',
      image: 'https://housecraft.me/gfhdjsdhfd333.png',
      services: [
        'كشف تسريبات المياه بدون تكسير',
        'إصلاح تسريبات الخزانات',
        'تركيب خلاطات ومغاسل',
        'تركيب وصيانة السخانات',
        'تسليك مجاري ومصارف',
        'تركيب مضخات المياه',
        'تمديدات سباكة جديدة',
        'عزل الحمامات والمطابخ',
        'تركيب فلاتر المياه',
        'صيانة دورات المياه'
      ],
      benefits: [
        'أحدث أجهزة الكشف',
        'سباكون محترفون',
        'ضمان ضد التسريب',
        'عمل نظيف ومرتب'
      ]
    }
  ];

  const additionalServices = [
    {
      icon: Wrench,
      title: 'الصيانة الدورية',
      description: 'عقود صيانة شاملة للمنازل والمنشآت'
    },
    {
      icon: Shield,
      title: 'الصيانة الطارئة',
      description: 'خدمة فورية على مدار الساعة'
    },
    {
      icon: Award,
      title: 'استشارات فنية',
      description: 'نصائح وإرشادات من خبرائنا مجاناً'
    },
    {
      icon: Clock,
      title: 'فحص دوري',
      description: 'فحص شامل لأنظمة منزلك'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white" dir="rtl">
      {/* Header */}
      <header className="fixed top-0 w-full bg-white/95 backdrop-blur-md shadow-sm z-50 border-b border-slate-200">
        <div className="container mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-3">
              <a href="/">
                <img 
                  src="https://customer-assets.emergentagent.com/job_trusted-handyman-1/artifacts/bwyuu9dw_IMG_0972.jpeg" 
                  alt="هاوس كرافت - خدمات صيانة منزلية بريدة" 
                  className="h-12 w-auto"
                />
              </a>
            </div>
            <nav className="hidden md:flex items-center gap-6">
              <a href="/" className="text-slate-600 hover:text-cyan-600 font-semibold transition-colors">الرئيسية</a>
              <a href="/services" className="text-cyan-600 font-semibold">الخدمات</a>
              <a href="/about" className="text-slate-600 hover:text-cyan-600 font-semibold transition-colors">من نحن</a>
              <a href="/contact" className="text-slate-600 hover:text-cyan-600 font-semibold transition-colors">اتصل بنا</a>
            </nav>
            <Button 
              onClick={() => window.open(whatsappLink, '_blank')}
              className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <MessageCircle className="w-4 h-4 ml-2" />
              احجز الآن
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-cyan-50 via-white to-slate-50 opacity-60"></div>
        <div className="container mx-auto relative z-10 text-center">
          <h1 className="text-5xl lg:text-6xl font-bold text-slate-900 mb-6">
            خدماتنا في <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-cyan-500">بريدة</span>
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            نقدم مجموعة شاملة من خدمات الصيانة المنزلية في بريدة بأعلى معايير الجودة والاحترافية. فريقنا من الفنيين المعتمدين جاهز لخدمتك على مدار الساعة.
          </p>
        </div>
      </section>

      {/* Main Services */}
      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto">
          <div className="space-y-20">
            {services.map((service, index) => (
              <div key={index} className={`grid lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <div className="relative h-96 rounded-2xl overflow-hidden shadow-2xl">
                    <img 
                      src={service.image} 
                      alt={`${service.title} في بريدة`}
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                    <div className="absolute bottom-6 right-6 bg-white p-4 rounded-xl shadow-lg">
                      <service.icon className="w-10 h-10 text-cyan-600" />
                    </div>
                  </div>
                </div>
                
                <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <div className="inline-flex items-center gap-2 bg-cyan-100 text-cyan-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                    <Award className="w-4 h-4" />
                    خدمة معتمدة
                  </div>
                  <h2 className="text-4xl font-bold text-slate-900 mb-4">{service.title}</h2>
                  <p className="text-xl text-slate-600 mb-6">{service.description}</p>
                  
                  <div className="space-y-6 mb-8">
                    <div>
                      <h3 className="text-xl font-bold text-slate-900 mb-3">ما نقدمه:</h3>
                      <div className="grid sm:grid-cols-2 gap-3">
                        {service.services.slice(0, 6).map((item, idx) => (
                          <div key={idx} className="flex items-start gap-2">
                            <CheckCircle className="w-5 h-5 text-cyan-600 flex-shrink-0 mt-0.5" />
                            <span className="text-slate-700">{item}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                    
                    <div className="bg-slate-50 rounded-xl p-6">
                      <h4 className="font-bold text-slate-900 mb-3">مميزات الخدمة:</h4>
                      <div className="grid sm:grid-cols-2 gap-3">
                        {service.benefits.map((benefit, idx) => (
                          <div key={idx} className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-cyan-600 rounded-full"></div>
                            <span className="text-slate-700 text-sm">{benefit}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  
                  <Button 
                    onClick={() => window.open(whatsappLink, '_blank')}
                    size="lg"
                    className="bg-gradient-to-r from-cyan-600 to-cyan-700 hover:from-cyan-700 hover:to-cyan-800 text-white font-bold"
                  >
                    <MessageCircle className="w-5 h-5 ml-2" />
                    اطلب الخدمة الآن
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="py-20 px-4 bg-gradient-to-br from-slate-50 to-cyan-50">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">خدمات إضافية</h2>
            <p className="text-xl text-slate-600">مزيد من الحلول لراحتك</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {additionalServices.map((service, index) => (
              <Card key={index} className="text-center hover:shadow-2xl transition-all border-2 hover:border-cyan-500 group">
                <CardContent className="p-8">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-2xl mb-4 group-hover:scale-110 transition-transform">
                    <service.icon className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3">{service.title}</h3>
                  <p className="text-slate-600">{service.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto">
            <Card className="bg-gradient-to-br from-cyan-50 to-white border-2 border-cyan-200">
              <CardContent className="p-8">
                <h2 className="text-3xl font-bold text-slate-900 mb-6 text-center">نغطي جميع أحياء بريدة</h2>
                <p className="text-lg text-slate-700 text-center mb-6">
                  فريقنا جاهز للوصول إليك في أي منطقة ببريدة بأسرع وقت ممكن
                </p>
                <div className="grid md:grid-cols-3 gap-4 text-center">
                  <div className="bg-white p-4 rounded-lg">
                    <Clock className="w-8 h-8 text-cyan-600 mx-auto mb-2" />
                    <div className="font-bold text-slate-900">وصول سريع</div>
                    <div className="text-sm text-slate-600">خلال ساعة</div>
                  </div>
                  <div className="bg-white p-4 rounded-lg">
                    <Shield className="w-8 h-8 text-cyan-600 mx-auto mb-2" />
                    <div className="font-bold text-slate-900">خدمة مضمونة</div>
                    <div className="text-sm text-slate-600">ضمان شامل</div>
                  </div>
                  <div className="bg-white p-4 rounded-lg">
                    <Award className="w-8 h-8 text-cyan-600 mx-auto mb-2" />
                    <div className="font-bold text-slate-900">فنيون معتمدون</div>
                    <div className="text-sm text-slate-600">خبرة 10+ سنوات</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-cyan-600 to-cyan-700">
        <div className="container mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            جاهزون لخدمتك على مدار الساعة
          </h2>
          <p className="text-xl text-cyan-50 mb-8 max-w-2xl mx-auto">
            احصل على خدمة صيانة احترافية الآن. فريقنا جاهز للوصول إليك في بريدة
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg"
              onClick={() => window.open(whatsappLink, '_blank')}
              className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white text-xl font-bold py-7 px-10 rounded-xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105"
            >
              <MessageCircle className="w-6 h-6 ml-2" />
              تواصل عبر واتساب
            </Button>
            <Button 
              size="lg"
              onClick={() => window.location.href = '/contact'}
              variant="outline"
              className="bg-white text-cyan-600 border-2 border-white hover:bg-cyan-50 text-xl font-bold py-7 px-10 rounded-xl transition-all"
            >
              <Phone className="w-6 h-6 ml-2" />
              اتصل بنا مباشرة
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-12 px-4">
        <div className="container mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <img 
                src="https://customer-assets.emergentagent.com/job_trusted-handyman-1/artifacts/bwyuu9dw_IMG_0972.jpeg" 
                alt="هاوس كرافت" 
                className="h-12 w-auto mb-4 brightness-200"
              />
              <p className="text-slate-400">
                شريكك الموثوق في الصيانة المنزلية ببريدة
              </p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">روابط سريعة</h3>
              <ul className="space-y-2 text-slate-400">
                <li><a href="/" className="hover:text-white transition-colors">الرئيسية</a></li>
                <li><a href="/services" className="hover:text-white transition-colors">الخدمات</a></li>
                <li><a href="/about" className="hover:text-white transition-colors">من نحن</a></li>
                <li><a href="/contact" className="hover:text-white transition-colors">اتصل بنا</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">خدماتنا</h3>
              <ul className="space-y-2 text-slate-400">
                <li>صيانة التكييف</li>
                <li>خدمات الكهرباء</li>
                <li>خدمات السباكة</li>
                <li>صيانة دورية</li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-4">تواصل معنا</h3>
              <div className="space-y-3">
                <a href={`tel:${whatsappNumber}`} className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors">
                  <Phone className="w-5 h-5" />
                  {whatsappNumber}
                </a>
                <p className="text-slate-400">بريدة، القصيم، المملكة العربية السعودية</p>
              </div>
            </div>
          </div>
          <div className="border-t border-slate-800 pt-8 text-center text-slate-400">
            <p>© 2024 هاوس كرافت. جميع الحقوق محفوظة.</p>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 left-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-110 z-50 animate-pulse"
      >
        <MessageCircle className="w-7 h-7" />
      </a>
    </div>
  );
};

export default Services;
